import React from "react";

import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Toolbar,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";

const Menu = ({ setSection, menuSections }) => {
  const theme = useTheme();

  return (
    <Drawer
      sx={{
        width: "100%",
        height: "100%",
        flexShrink: 0,
        color: "#fff",
        position: "relative",
        "& .MuiDrawer-paper": {
          position: "absolute",
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 25%, #090909)`,
          width: "100%",
          boxSizing: "border-box",
          overflow: "hidden",
        },
      }}
      variant="permanent"
      anchor="left">
      <Box
        bgcolor="primary.dark"
        style={{
          position: "absolute",
          top: "-10%",
          right: "-20%",
          width: "80%",
          zIndex: -1,
          paddingBottom: "80%",
          borderRadius: "50%",
        }}
      />
      <Toolbar />
      <Divider />
      {menuSections.map(({ subHeader, subItem }) => (
        <List
          sx={{
            color: "#fff",
          }}>
          <SubHeader theme={theme}>{subHeader}</SubHeader>
          {subItem.map((text, index) => (
            <ListItem
              button
              key={text}
              onClick={() => setSection(text.toLowerCase())}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      ))}
      {/*  <List
        sx={{
          color: "#fff",
        }}>
        <SubHeader theme={theme}>Financials</SubHeader>
        {["Payments & Fees"].map((text, index) => (
          <ListItem
            button
            key={text}
            onClick={() => setSection(text.toLowerCase())}>
          
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List
        sx={{
          color: "#fff",
        }}>
        <SubHeader theme={theme} r>
          Administrative
        </SubHeader>
        {["Class", "Students", "Staff"].map((text, index) => (
          <ListItem
          button
          key={text}
          onClick={() => setSection(text.toLowerCase())}>
            
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <List
        sx={{
          color: "#fff",
        }}>
        <SubHeader theme={theme}>Utilities</SubHeader>
        {["Upcoming Events"].map((text, index) => (
          <ListItem
            button
            key={text}
            onClick={() => setSection(text.toLowerCase())}>
            
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List> */}
    </Drawer>
  );
};

export default Menu;

const SubHeader = ({ theme, children }) => (
  <ListSubheader
    sx={{
      color: theme.palette.secondary.light,
      background: "none",
      boxShadow: theme.shadows[3],
    }}>
    {children}
  </ListSubheader>
);
